module.exports = __webpack_public_path__ + "static/media/SourceHanSansCN-Normal.8000d778.eot";